class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-theoric-items');
      if (cartItems) {
        cartItems.updateQuantity(this.dataset.index, 0, event);
      }
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER || 500);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'cart-items') {
          return;
        }
        this.onCartUpdate(event);
      });
    }
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (input) {
      input.value = input.getAttribute('value');
    }
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = Number.parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue === 0) {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        0,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
      return;
    }

    if (inputValue < event.target.dataset.min) {
      message = (window.quickOrderListStrings && window.quickOrderListStrings.min_error) ? window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min) : `Mínimo: ${event.target.dataset.min}`;
    } else if (inputValue > Number.parseInt(event.target.max)) {
      message = (window.quickOrderListStrings && window.quickOrderListStrings.max_error) ? window.quickOrderListStrings.max_error.replace('[max]', event.target.max) : `Máximo: ${event.target.max}`;
    } else {
      const parsedStep = Number.parseInt(event.target.step);
      const step = Number.isNaN(parsedStep) ? 1 : parsedStep;
      if (inputValue % step !== 0) {
        message = (window.quickOrderListStrings && window.quickOrderListStrings.step_error) ? window.quickOrderListStrings.step_error.replace('[step]', step) : `O valor deve ser múltiplo de ${step}`;
      }
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate(event) {
    if (this.closest('cart-theoric')) {
      return;
    }

    return fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceContent = html.querySelector('cart-items') || html.querySelector('.js-contents');
        if (sourceContent) {
          this.innerHTML = sourceContent.innerHTML;
        }
      })
      .catch((e) => {
        console.error('Erro ao atualizar cart-items na página principal:', e);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id || 'main-cart-items',
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id || 'main-cart-footer',
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    this.enableLoading(line);

    // GA4 — capture item data before the request for remove_from_cart
    const _prevQuantity = quantity;
    let _removedItemData = null;
    if (quantity === 0) {
      try {
        const lineEl = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineEl) {
          const nameEl = lineEl.querySelector('.cart-item__name');
          const priceEl = lineEl.querySelector('.cart-item__price .price--end, .product-option .price, [data-cart-item-price]');
          _removedItemData = {
            item_id: String(variantId || ''),
            item_name: nameEl ? nameEl.textContent.trim() : '',
          };
        }
      } catch(e) {}
    }

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          if (quantityElement) quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartTheoricWrapper = document.querySelector('cart-theoric');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartTheoricWrapper) cartTheoricWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);

          if (elementToReplace && parsedState.sections[section.section]) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== Number.parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error || 'Erro desconhecido.';
          } else {
            message = (window.cartStrings && window.cartStrings.quantityError) ? window.cartStrings.quantityError.replace('[quantity]', updatedValue) : `Quantidade atualizada para ${updatedValue}.`;
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          if (cartTheoricWrapper && typeof trapFocus === 'function') {
            trapFocus(cartTheoricWrapper, lineItem.querySelector(`[name="${name}"]`));
          } else if (lineItem.querySelector(`[name="${name}"]`)) {
            lineItem.querySelector(`[name="${name}"]`).focus();
          }
        } else if (parsedState.item_count === 0 && cartTheoricWrapper && typeof trapFocus === 'function') {
          trapFocus(cartTheoricWrapper.querySelector('.drawer__inner-empty') || cartTheoricWrapper, cartTheoricWrapper.querySelector('a') || cartTheoricWrapper.querySelector('button'));
        } else if (document.querySelector('.cart-item') && cartTheoricWrapper && typeof trapFocus === 'function') {
          trapFocus(cartTheoricWrapper, document.querySelector('.cart-item__name'));
        }

        // GA4 — remove_from_cart
        if (_prevQuantity === 0 && _removedItemData) {
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
              event: 'remove_from_cart',
              ecommerce: {
                currency: window.Shopify?.currency?.active || 'BRL',
                items: [_removedItemData],
              },
            });
          } catch(e) {}
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        }
      })
      .catch((e) => {
        console.error('Erro na requisição de mudança de quantidade:', e);
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings.error || 'Ocorreu um erro.';
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    if (cartStatus) {
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }
  }

  getSectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    if (document.activeElement) document.activeElement.blur();
    if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (mainCartItems) mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

class CartTheoric extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    const overlay = this.querySelector('#TheoricCartDrawer #CartTheoric-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }
    this.setHeaderCartIconAccessibility();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdateEvent.bind(this));
    }

  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // Com o carrinho do Kaching na pagina, quem abre e ele: esta gaveta fica inativa
    // (sem isso as duas abriam juntas ao clicar no icone ou adicionar um item).
    if (document.querySelector('kaching-cart')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // GA4 — view_cart
    try {
      fetch('/cart.js').then(r => r.json()).then(cart => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'view_cart',
          ecommerce: {
            currency: window.Shopify?.currency?.active || 'BRL',
            value: cart.total_price / 100,
            items: (cart.items || []).map((item, idx) => ({
              item_id: String(item.variant_id),
              item_name: item.title,
              item_brand: item.vendor || '',
              price: item.final_price / 100,
              quantity: item.quantity,
              index: idx,
            })),
          },
        });
      });
    } catch(e) {}

    this.classList.add('active');

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartTheoric');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        if (typeof trapFocus === 'function') {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    scrollLock.lock();
  }

  close() {
    this.classList.remove('active');
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this.activeElement);
    }
    scrollLock.unlock();

  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (typeof onKeyUpEscape === 'function') {
      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-theoric',
        selector: '#CartTheoric',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  renderContents(parsedState, options = {}) {
    const drawerInner = this.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');

    this.productId = parsedState.id;

    try {
      this.getRenderSections().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;

        const sectionHtml = parsedState.sections[section.id];
        if (!sectionHtml) return;

        sectionElement.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      });
    } catch (e) {
      console.error('[CartTheoric] Erro ao renderizar seções:', e);
    }

    setTimeout(() => {
      const overlay = this.querySelector('#CartTheoric-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      if (!options.silent) this.open();
    });
  }

  getRenderSections() {
    return [
      {
        id: 'cart-theoric',
        selector: '#CartTheoric',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  updateDrawerDOM(newCartTheoric) {
    const newDrawerInner = newCartTheoric.querySelector('.drawer__inner');
    const currentDrawerInner = this.querySelector('.drawer__inner');
    if (newDrawerInner && currentDrawerInner) {
      currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
    }

    const newDrawerFooter = newCartTheoric.querySelector('.drawer__footer');
    const currentDrawerFooter = this.querySelector('.drawer__footer');
    if (newDrawerFooter && currentDrawerFooter) {
      currentDrawerFooter.innerHTML = newDrawerFooter.innerHTML;
    }

    const overlay = this.querySelector('#CartTheoric-Overlay');
    if (overlay) {
      overlay.addEventListener('click', this.close.bind(this));
    }

  }

  updateCartState(itemCount) {
    this.classList.toggle('is-empty', itemCount === 0);

    const ritualTabButton = this.querySelector('.tabs button[onclick*="cart-items-tab"]');
    if (ritualTabButton) {
      ritualTabButton.textContent = `Sua bolsa personalizada (${itemCount})`;
    }
  }

  async updateCartIconBubble() {
    const cartBubbleHtml = await fetch(`${routes.cart_url}?section_id=cart-icon-bubble`).then(r => r.text());
    const cartBubbleElement = document.getElementById('cart-icon-bubble');

    if (cartBubbleElement && cartBubbleHtml) {
      const bubbleHtml = new DOMParser().parseFromString(cartBubbleHtml, 'text/html');
      const newBubbleContent = bubbleHtml.querySelector('.shopify-section');
      if (newBubbleContent) {
        cartBubbleElement.innerHTML = newBubbleContent.innerHTML;
      }
    }
  }

  async handleCartUpdateEvent(event) {
    if (event.source === 'product-form') return;

    try {
      const cartDataResponse = await fetch(`${routes.cart_url}.js`);
      const cartData = await cartDataResponse.json();

      const sectionIdToFetch = 'cart-theoric';
      const response = await fetch(`${routes.cart_url}?section_id=${sectionIdToFetch}`);
      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      const newCartTheoric = html.querySelector('cart-theoric');

      if (!newCartTheoric) {
        console.error('[CartTheoric] Elemento <cart-theoric> não encontrado no HTML retornado.');
        return;
      }

      this.updateDrawerDOM(newCartTheoric);
      this.updateCartState(cartData.item_count);
      await this.updateCartIconBubble();

    } catch (error) {
      console.error('[CartTheoric] Erro ao processar atualização do drawer:', error);
    }
  }
}

customElements.define('cart-theoric', CartTheoric);

class CartTheoricItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'TheoricCartDrawer',
        section: 'cart-theoric',
        selector: '.drawer__contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-theoric-items', CartTheoricItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
              .then(() => {
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
                  publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-note-update', cartData: { note: event.target.value } });
                }
              })
              .catch(e => console.error('Erro ao atualizar nota do carrinho:', e));
          }, ON_CHANGE_DEBOUNCE_TIMER || 500)
        );
      }
    }
  );
}
